// Copyright (c) 2019-2020 Verimatrix, Inc.  All Rights Reserved.

import React, {Component} from 'react'

import MenuItem from '..'

import ContactSupportOutlinedIcon from '@material-ui/icons/ContactSupportOutlined'

class ProtectMyApp extends Component {

  render () {
    return (
      <MenuItem
        title='Product Details'
        buttonText={<><ContactSupportOutlinedIcon />Contact our sales team</>}
        href={'https://www.verimatrix.com/online-contact-form'}
      >
        <div className='protect-my-app product-details'>
          <div className='row title'>
            <p>Verimatrix® is the leading provider of software security solutions. Whitebox enables you to build, control and trust your own software crypto-security.</p>
          </div>
          <div className='row text'>
            <ul>
              <li className='lh'>{'Protect My App key features include:'}</li>
              <li>{'Protect sensitive data, keys and algorithms even when running in exposed environments '}</li>
              <li>{'No added dependencies, so apps can easily be deployed anywhere '}</li>
              <li>{'Retain full control of business-critical crypto keys '}</li>
              <li>{'Easily design and create your crypto architectures with our graphical designer '}</li>
              <li>{'High performance, even on restricted devices such as mobile and IoT'}</li>
            </ul>
          </div>
        </div>
      </MenuItem>
    )
  }
}

export default (ProtectMyApp)
